import { render, staticRenderFns } from "./get-inspired.vue?vue&type=template&id=548a4090"
import script from "./get-inspired.vue?vue&type=script&lang=js"
export * from "./get-inspired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports